import React from 'react';
import './FinalCTA.css';

const FinalCTA = () => {
  return (
    <section className="final-cta-section">
      <div className="final-cta-glow"></div>
      <div className="final-cta-container">
        <h2 className="final-cta-title">Ready to Forge Your Future?</h2>
        <p className="final-cta-description">
          Join the next generation of AI-powered workflows and scale your operations with unprecedented speed.
        </p>
        <button className="final-cta-button">Get Started Now</button>
      </div>
    </section>
  );
};

export default FinalCTA;
